import { render, staticRenderFns } from "./PrefSelect.vue?vue&type=template&id=7918e8fe&lang=pug"
import script from "./PrefSelect.vue?vue&type=script&lang=js"
export * from "./PrefSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports